/* eslint-disable @typescript-eslint/no-explicit-any */
import {Directive, ElementRef, EventEmitter, HostListener, Output, Renderer2} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: 'ds-text-field,ds-select-field,ds-radiogroup,ds-date-field,ds-hybrid-field',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DsValueAccessorDirective,
      multi: true,
    },
  ],
})
export class DsValueAccessorDirective implements ControlValueAccessor {

  @Output() keyUp = new EventEmitter<string>();

  constructor(private element: ElementRef, private renderer: Renderer2) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    this.onChange = () => {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    this.onTouched = () => {};
  }

  onChange: (value: string) => void;
  onTouched: () => void;

  writeValue(value: string) {
    this.renderer.setProperty(this.element.nativeElement, 'value', value);
  }

  @HostListener('dsChange', ['$event.detail'])
  _handleIllyChange(detail: any) {
    this.onChange(detail.value);
  }

  @HostListener('dsSelectChange', ['$event.detail'])
  _handleIllyChangeSelect(detail: any) {
    this.onChange(detail.selected.value);
  }

  @HostListener('dsDateChange', ['$event.detail'])
  _handleIllyChangeDate(detail: any) {
    this.onChange(detail.value);
  }

  @HostListener('dsRadioGroupChange', ['$event.detail'])
  _handleIllyChangeRadio(detail: any) {
    this.onChange(detail.selectedValue);
  }

  @HostListener('onBlur', ['$event.target'])
  _handleBlurEvent() {
    this.onTouched();
  }

  @HostListener('dsHybridFieldSelect', ['$event.detail'])
  _handleIllyChangeHybridField(detail: any) {
    this.onChange(detail.selected.value);
  }

  registerOnChange(fn: (value: string) => void) {
    this.onChange = (value) => {
      fn(value);
    };
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = () => {
      fn();
    };
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(
      this.element.nativeElement,
      'disabled',
      isDisabled
    );
  }
}
